<h1 mat-dialog-title>
  Disconnected
</h1>

<div mat-dialog-content>
  Disconnected - please click Reload to reload the application
</div>

<div style="position:relative" mat-dialog-actions>
  <button mat-raised-button [color]="'glb_greenbtn'" (click)="reloadAction()">Reload</button>
  <span style="position:absolute;right:0;font-size:12px;">Reload after {{counter}}s</span>
</div>